import { render } from "./Button.vue?vue&type=template&id=3322c2b2&scoped=true"
const script = {}

import "./Button.vue?vue&type=style&index=0&id=3322c2b2&scoped=true&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3322c2b2"]])

export default __exports__